const Pedicure = () => {
  return (
    <div>
      <h1>Pedikűr Szolgáltatások</h1>
      <p>
        Lábaink ápolása kiemelten fontos minden évszakban, hiszen a nyári
        frissesség és a téli elegancia is elengedhetetlen. Bőrkeményedéseink
        eltüntetését érdemes szakemberre bízni, így könnyed léptekkel járhatunk
        utána. Szakszerűen kezeljük az enyhén benőtt köröm problémáit is, hogy
        megszabaduljunk a kellemetlenségektől.
      </p>
      <br></br>
      <div className="pedicure">
        <h3>
          <u>PEDIKŰR</u>
        </h3>
        <p>Az alábbi pedikűr szolgáltatások közül választhatunk:</p>
        <span>Esztétikai pedikűr - 14000 Ft</span>
        <br></br>
        <span>Esztétikai pedikűr - Extra - 13000 Ft</span> <br></br>
        <span>Esztétikai pedikűr egyszínű gél lakkal - 12000 Ft</span> <br></br>
        <span>Esztétikai pedikűr prémium gél lakkal - 16000 Ft</span> <br></br>
        <span>Gél lakk lábra - egyszínű - 10000 Ft</span> <br></br>
        <span>Gél lakk lábra (francia, ombre) - 12000 Ft</span> <br></br>
        <span>Gél lakk lábra - prémium - 15000 Ft</span> <br></br>
        <span>Gél lakk végleges eltávolítása - 4000 Ft</span> <br></br>
        <span>
          Gél lakk végleges eltávolítása esztétikai pedikűrrel - 10000 Ft
        </span>
        <br></br>
        <span>Köröm korrekciója (más szolgáltatás mellé) - 2500 Ft / db</span>
        <p>
          Reméljük, hogy ezek a pedikűr szolgáltatások segítenek megőrizni
          lábaink szépségét és egészségét, és teljes mértékben elégedettek
          leszünk a végeredménnyel!
        </p>
      </div>
      <br></br>
      <br></br>
      <div className="pedicure">
        <h3>
          <u>ANTI-AGE BŐRRFIATALÍTÓ PEDIKŰR</u>
        </h3>
        <p>
          Az Anti-Age bőrfiatalító pedikűr az ideális ötvözete a hagyományos
          kézi pedikűrnek, a SPA lábápolásnak és a bőrfiatalításnak, ami egy
          aromaterápiás kényeztető luxus csomag.
        </p>
        <span>Ár: 22000 Ft</span>
        <br></br>
        <span>Kezelési idő: kb.1 óra</span>
        <br></br>
        <span>
          <u>Kezelés menete:</u>
        </span>
        <li>Frissítő és fertőtlenítő lábáztatás holt tengeri sóval</li>
        <li>Szakszerű kézi pedikűr</li>
        <li>Bőroldóval körömbőr feltolása, eltávolítása </li>
        <li>Hámlasztó bőrradír</li>
        <li>
          Mélytápláló maszk, a puhító pakolással a teljes lábat betekerve
          pihentetjük
        </li>
        <li>Krémezés természetes hatóanyagú krémmel</li>
        <p>
          Ez a különleges pedikűr kezelés segít megőrizni és fiatalítani a
          bőrödet, miközben teljes relaxációt biztosít a lábaidnak.
        </p>
      </div>
      <br></br>
      <br></br>
      <div className="pedicure">
        <h3>
          <u>SPA PEDIKŰR</u>
        </h3>
        <span>Ár: 13000 Ft</span>
        <br></br>
        <span>Kezelési idő: kb. 60 perc</span> <br></br>
        <span>
          <u>Kezelés menete:</u>
        </span>
        <li>Lábáztatás Holt-tengeri sóval</li>
        <li>Szakszerű kézi pedikűr</li>
        <li>Bőroldó segítségével a körömbőr feltolása és eltávolítása</li>
        <li>Krémezés természetes hatóanyagokat tartalmazó krémmel</li>
        <li>Nylon és pamutkesztyű felhelyezése, majd pár perces pihenőidő</li>
      </div>
      <br></br>
      <br></br>
      <div className="pedicure">
        <h3>
          <u>LÁBKÖRÖM ERŐSÍTÉS GUMI ZSELÉVEL (RUBBER)</u>
        </h3>
        <p>
          A lábköröm erősítése és formázása zselével. Tartóssága miatt nem
          szükséges állandóan újralakkozni. Esztétikus, szép körömforma
          kialakítása. Gyenge, töredezett köröm megerősítése.
        </p>

        <span>Ár: 14000 Ft</span>
        <br></br>
        <span>Kezelési idő: kb. 90 perc</span>
        <br></br>
        <span>
          <u>Kezelés menete:</u>
        </span>
        <li>SPA fürdő</li>
        <li>Régi lakk eltávolítása</li>
        <li>Köröm előkészítése</li>
        <li>Köröm zsírtalanítása</li>
        <li>
          A zselét vékony rétegben felvisszük, majd UV lámpában megköttetjük.
        </li>
        <li>Formázás, fényzselé alkalmazása</li>
      </div>
      <br></br>
      <br></br>
      <div className="pedicure">
        <h3>
          <u>KÖRÖM PROTÉZIS / darab</u>
        </h3>
        <p>
          A körömprotézis egy technika, amelynek segítségével mesterséges kéz-
          és lábköröm készíthető. A pótlást közvetlenül a körömcsonkra építjük,
          így eltakarva a sérült részt, amely hónapokig használható. A
          körömprotézis ideális megoldást nyújthat esztétikailag zavaró, sérült
          vagy hiányzó körmök esetén.
        </p>
        <p>
          A kezelést követően a köröm igény szerint lakkal vagy géllakkal
          borítható.
        </p>
        <span>Ár: 5000 Ft</span>
        <br></br>
        <span>Kezelési idő: kb. 60 perc</span>
      </div>
      <br></br>
      <br></br>{" "}
      <div className="pedicure">
        <h3>
          <u>3TO SPANGE</u>
        </h3>
        <p>
          A benőtt lábköröm fájdalom és operáció mentes kezelése. A fogszabályzó
          elve alapján működő rugósacél kapocs /SPANGE/ a köröm növekedését
          szabályozza. A 3TO-terápia a köröm természetes növekedési irányát
          állítja helyre. A benőtt lábköröm felemelésével azonnali fájdalom
          csökkenés érhető el, így a beteg közérzete is javul.
        </p>
        <div className="text_align_left">
          <u>A 3TO-SPANGE lényeges tulajdonságai:</u>
          <br></br>
          <br></br>
          <li>könnyen feltehető</li>
          <li>a húzóerő egyénileg szabályozható</li>
          <li>anyaga speciális rugós nemesacél</li>
          <li>gyulladás esetén is kifejti hatását</li>
          <li>nem zárja el a körmöt és a bőrt a levegőtől</li>
          <li>azonnali fájdalomcsökkenés/mentesség a felhelyezés után</li>
          <li>a fájdalmas operáció az esetek 90%-ban elkerülhető</li>
          <li>a cipőviselést nem befolyásolja</li>
        </div>
        <p>
          A kezelés ideje függ a köröm növekedésének gyorsaságától. A SPANGET
          rendszeresen ellenőrizni és áthelyezni kell, ez a felhelyezés után 3
          hetente történik a tünetmentességig.
        </p>
        <span>
          <u>Kezelés menete:</u>
        </span>
        <br></br>
        <li>SPA fürdő</li>
        <li>a kezelendő felület fertőtlenítése</li>
        <li>köröm benövés eltávolítása</li>
        <li>a spanget bevezetjük a körömágy és a köröm közé</li>
        <li>
          a jobb és a bal oldali spange behelyezése után, összehúzó drót
          segítségével összehúzzuk
        </li>
        <li>
          a drótvégeket levágjuk,majd lefedjük, így elkerüljük a zokni, harisnya
          stb… beakadását
        </li>
        <br></br>
        <span>Ár: 15000 Ft</span>
        <br></br>
        <span>Felhelyezési idő 1 óra, pedikűrrel 2 óra.</span>
      </div>
      <br></br>
      <br></br>
      <div className="pedicure">
        <h3>
          <u>COMBI PED SPANGE</u>
        </h3>

        <p>
          A COMB Iped spange alkalmazható fájó, deformálódott, benőtt és
          csőkörmök esetén. Lehetővé teszi a drótos körömszabályozó
          alkalmazását, ha a körömsáncnak csak az egyik oldalához lehet
          hozzáférni. Az alkalmazástól függően a köröm egyik, vagy akár mindkét
          oldalán fejti ki hatását.
        </p>
        <p>
          Az új COMBIped drótos-ragasztós spange az eredeti 3TO-Spange és a
          ragasztós Podofix spange kombinációjából született meg és ezek
          előnyeit ötvözi.
        </p>
        <span>
          <u>Kezelés menete:</u>
        </span>
        <li>SPA fürdő</li>
        <li>a kezelendő felület fertőtlenítése</li>
        <li>köröm benövés eltávolítása</li>
        <li>
          COMBIped körömszabályozó erősségét és hosszúságát a pácienshez
          igazítjuk
        </li>
        <li>drót megformázása, illetve felhelyezése a körömre</li>
        <li>felesleges részek eltávolítása</li>
        <p>
          Ez a módszer minden korosztály számára alkalmazható, gyermeknél és
          cukorbetegeknél egyaránt.
        </p>
        <span>Ár: 13000 Ft</span>
        <br></br>
        <span>Felhelyezési idő 1 óra, pedikűrrel 2 óra</span>
      </div>
      <br></br> <br></br>
    </div>
  );
};

export default Pedicure;
